import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0090ec8d")

_pushScopeId("data-v-0090ec8d")
const _hoisted_1 = { class: "overlay-infos" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { style: {"flex":"1"} }
const _hoisted_4 = { class: "content" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("General")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Restricted Areas")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Custom Roads")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx, _cache) => {
  const _component_calcite_tab_title = _resolveComponent("calcite-tab-title")
  const _component_calcite_tab_nav = _resolveComponent("calcite-tab-nav")
  const _component_GeneralInformation = _resolveComponent("GeneralInformation")
  const _component_calcite_tab = _resolveComponent("calcite-tab")
  const _component_RestrictedAreas = _resolveComponent("RestrictedAreas")
  const _component_CustomRoads = _resolveComponent("CustomRoads")
  const _component_UploadOverlay = _resolveComponent("UploadOverlay")
  const _component_calcite_tabs = _resolveComponent("calcite-tabs")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("span", _hoisted_3, _toDisplayString(_ctx.overlay?.Name), 1),
      _createVNode("span", {
        class: ["esri-icon-close icon", {'disable-click': _ctx.click}],
        onClick: _cache[1] || (_cache[1] = (...args) => (_ctx.closeOverlay && _ctx.closeOverlay(...args)))
      }, null, 2)
    ]),
    _createVNode("div", _hoisted_4, [
      _createVNode(_component_calcite_tabs, null, {
        default: _withId(() => [
          _createVNode(_component_calcite_tab_nav, { slot: "tab-nav" }, {
            default: _withId(() => [
              _createVNode(_component_calcite_tab_title, {
                active: "",
                style: {"width":"120px"}
              }, {
                default: _withId(() => [
                  _hoisted_5
                ]),
                _: 1
              }),
              _createVNode(_component_calcite_tab_title, { style: {"width":"120px"} }, {
                default: _withId(() => [
                  _hoisted_6
                ]),
                _: 1
              }),
              (_ctx.isV8)
                ? (_openBlock(), _createBlock(_component_calcite_tab_title, {
                    key: 0,
                    style: {"width":"120px"}
                  }, {
                    default: _withId(() => [
                      _hoisted_7
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_calcite_tab_title, { style: {"width":"120px"} }, {
                default: _withId(() => [
                  _createTextVNode(_toDisplayString(_ctx.publishTabName), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_calcite_tab, {
            active: "",
            style: {"width":"100%"}
          }, {
            default: _withId(() => [
              _createVNode(_component_GeneralInformation)
            ]),
            _: 1
          }),
          _createVNode(_component_calcite_tab, { style: {"width":"100%"} }, {
            default: _withId(() => [
              _createVNode(_component_RestrictedAreas)
            ]),
            _: 1
          }),
          (_ctx.isV8)
            ? (_openBlock(), _createBlock(_component_calcite_tab, {
                key: 0,
                style: {"width":"100%"}
              }, {
                default: _withId(() => [
                  _createVNode(_component_CustomRoads)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_calcite_tab, { style: {"width":"100%"} }, {
            default: _withId(() => [
              _createVNode(_component_UploadOverlay)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ]))
})